import { render, staticRenderFns } from "./ModalConfigChatYoutube.vue?vue&type=template&id=d012c002&scoped=true"
import script from "./ModalConfigChatYoutube.vue?vue&type=script&lang=js"
export * from "./ModalConfigChatYoutube.vue?vue&type=script&lang=js"
import style0 from "./ModalConfigChatYoutube.vue?vue&type=style&index=0&id=d012c002&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d012c002",
  null
  
)

export default component.exports